module.exports = __webpack_public_path__ + "static/media/interns.78cd8a7d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/interns.jpeg
// module id = 555
// module chunks = 4